import React from 'react';
import BabyDiaperVideo from '../../DiaperLandingPage/BabyDiaperVideo';
import { SectionContainer } from './styled';

function VideoContent(props) {
  const { productCategory, itemData } = props;

  const widgetData = itemData?.widgetContent?.[0];

  return (
    <SectionContainer noPadding productcategory={productCategory}>
      <BabyDiaperVideo aboutSection={true} videoUrl={widgetData?.url} />
    </SectionContainer>
  );
}

export default VideoContent;
